module.exports = __webpack_public_path__ + "img/slide15.a91195c6.png";